module.exports = __webpack_public_path__ + "img/150.f1125c96.png";